module.exports = __webpack_public_path__ + "img/pr-1.eaf9ed36.png";